﻿(function () {
  var COMPARE_GA_LIST_ID = 'openear_compare';
  var COMPARE_GA_BUTTON_NAME = 'Add to cart';

  function getCompareListMeta(root) {
    var listId = (root.getAttribute('data-compare-ga-list-id') || COMPARE_GA_LIST_ID).trim();
    return {
      listId: listId,
      listName: listId
    };
  }

  function getCardTitleFromButton(openBtn) {
    if (!openBtn) return '';
    var card = openBtn.closest('.card');
    if (!card) return '';
    var titleEl = card.querySelector('.card-title');
    return titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
  }

  function trackCompareCartClick(root, openBtn) {
    var listMeta = getCompareListMeta(root);
    var contentName = getCardTitleFromButton(openBtn) || listMeta.listName;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: listMeta.listId,
        content_name: contentName,
        button_name: COMPARE_GA_BUTTON_NAME
      }
    });
  }

  function initCompareModalGa(root) {
    if (!root || root.dataset.compareModalGaBound === 'true') return;
    root.dataset.compareModalGaBound = 'true';

    root.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-pcard-open-modal]');
      if (!openBtn || !root.contains(openBtn)) return;
      trackCompareCartClick(root, openBtn);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-openear-compare-modal-root]').forEach(initCompareModalGa);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-openear-compare-modal-root]');
    if (!root) return;
    delete root.dataset.compareModalGaBound;
    initCompareModalGa(root);
  });
})();
